import { useMediaQuery } from '@mui/material';

/**
 * @param {'xs' | 'sm' | 'md' | 'lg' | 'xl'} [breakpoint='sm'] - Breakpoint to check against
 * @returns {boolean} True if viewport is below the specified breakpoint
 */
const useIsMobile = (breakpoint = 'sm') => {
    return useMediaQuery((theme) => theme.breakpoints.down(breakpoint), { noSsr: true });
};

export default useIsMobile;
